import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskAnimalsIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            d='M13.4704 14.2299L8.95453 9.71574C10.0195 7.00158 11.9687 4.64862 14.5974 3.10254L14.6649 13.6261L13.4704 14.2299ZM22.6794 11.7257L21.1635 12.4298C20.7529 11.8851 20.1022 11.5326 19.3682 11.5326C18.3416 11.5326 17.4753 12.2207 17.2063 13.1611L13.2595 15.2123L1.67468 3.63232C0.364068 8.59911 1.81531 13.8549 5.38244 17.3939L5.37494 17.3958C4.70369 18.353 3.5215 19.0758 1.79366 19.0786C4.06147 21.4561 8.03918 21.2367 10.6005 19.9327L22.2114 13.2585C22.7467 12.9501 22.9511 12.2798 22.6792 11.7257L22.6794 11.7257Z'
        />
    ),
})

TaskAnimalsIcon.displayName = 'TaskAnimalsIcon'
